import { render } from "./checkSlips.vue?vue&type=template&id=78481621&scoped=true&ts=true"
import script from "./checkSlips.vue?vue&type=script&lang=ts"
export * from "./checkSlips.vue?vue&type=script&lang=ts"

import "./checkSlips.vue?vue&type=style&index=0&id=78481621&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78481621"]])

export default __exports__